<script setup>
import {ref} from "vue";
import {useInfiniteScroll} from "@vueuse/core";

const props = defineProps({
    data: {
        type: Array,
        required: true,
        default: () => []
    }
})

const emit = defineEmits(["loadMore"]);
const historyRef = ref(null);


useInfiniteScroll(
    historyRef,
    () => {
        emit("loadMore");
    },
    {
        distance: 50,
        interval: 300,
    }
);

const getDate = (date) => {
    if (!date) return;

    const dateObj = new Date(date);
    return dateObj.toISOString().slice(0, 10);
}
</script>

<template>
    <table>
        <thead class="thead">
        <tr>
            <th><span class="headed_text">{{ $t('page.subscriptions.history.table.date') }}</span></th>
            <th><span class="headed_text">{{ $t('page.subscriptions.history.table.amount') }}</span></th>
            <th><span class="headed_text">{{ $t('page.subscriptions.history.table.name') }}</span></th>
        </tr>
        </thead>

        <tbody class="compact-table" ref="historyRef">
        <tr v-for="(el, ind) in data" :key="ind">
            <td class="item-1">
                {{ getDate(el.date) }}
            </td>
            <td class="item-1">
                ${{ el.amount }}
            </td>
            <td class="item-1">
                {{ el.product_name }}
            </td>
        </tr>
        <tr style="border-bottom: none">
            <td :colspan="3">
                <slot name="information_column"/>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<style scoped lang="scss">
@use "@/styles/table.scss";

.item-1 {
    padding: 25px 15px;
}
</style>
